const apiKey = 'AIzaSyCQmJ2v2SRAzn9C6lw3h6cAZyr79oWyjBw'
export const googleMap = {
  loadGoogleMaps () {
    return new Promise((resolve, reject) => {
      if (window.google && window.google.maps) {
        resolve(window.google.maps)
        return
      }

      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initGoogleMaps&v=weekly&loading=async&language=hr&region=HR&libraries=drawing`
      script.async = true
      script.defer = true
      script.onerror = reject

      window.initGoogleMaps = () => resolve(window.google.maps)

      document.head.appendChild(script)
    })
  },

  mapId: '6999d94c51613f7d'
}
